import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Alert, Card, Field, ProjectSelect, addDays, btn, conflictsOf, input, iso, msg, primary } from "./common";

const LABEL = { double_booked: "already booked that day", expired_certification: "certification expired", missing_certification: "missing certification", unknown_worker: "unknown person" };

function monday(d = new Date()) { const x = new Date(d); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return iso(x); }

function Week({ start, rows }) {
  const days = [0, 1, 2, 3, 4, 5, 6].map((n) => addDays(start, n));
  return (
    <div className="grid gap-2 grid-cols-1 sm:grid-cols-7" data-testid="wf-calendar">
      {days.map((d) => (
        <div key={d} className="rounded border border-erf-borderCream bg-white p-2 min-h-[96px]" data-testid={`wf-day-${d}`}>
          <div className="text-xs font-semibold">{d}</div>
          {rows.filter((r) => r.work_date === d).map((r) => (
            <div key={r.id} className="mt-1 text-xs" data-testid={`wf-entry-${r.id}`}><strong>{r.project_name}</strong>: {r.workers.map((w) => w.name).join(", ")}</div>))}
        </div>))}
    </div>
  );
}

export default function Schedule({ projects, workers }) {
  const [start, setStart] = useState(monday());
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ project_id: "", work_date: iso(new Date()), worker_ids: [], override_reason: "" });
  const [conf, setConf] = useState([]);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/workforce/schedule", { params: { start, end: addDays(start, 6) } }).then((r) => setRows(r.data)).catch((e) => setErr(msg(e))), [start]);
  useEffect(() => { load(); }, [load]);
  const toggle = (id) => setF({ ...f, worker_ids: f.worker_ids.includes(id) ? f.worker_ids.filter((x) => x !== id) : [...f.worker_ids, id] });
  const save = () => api.post("/workforce/schedule", f).then(() => { setConf([]); setErr(""); load(); })
    .catch((e) => { setConf(conflictsOf(e)); setErr(msg(e)); });
  return (
    <section className="space-y-3" data-testid="wf-schedule">
      <div className="flex flex-wrap items-center gap-2"><h2 className="font-heading text-lg mr-auto">Crew schedule · week of {start}</h2>
        <button type="button" className={btn} onClick={() => setStart(addDays(start, -7))} data-testid="wf-week-prev">Previous week</button>
        <button type="button" className={btn} onClick={() => setStart(addDays(start, 7))} data-testid="wf-week-next">Next week</button></div>
      <Week start={start} rows={rows} />
      <Card testid="wf-schedule-form" className="grid gap-2 sm:grid-cols-3">
        <Field id="wf-s-project" label="Project"><ProjectSelect projects={projects} value={f.project_id} onChange={(v) => setF({ ...f, project_id: v })} testid="wf-s-project" /></Field>
        <Field id="wf-s-date" label="Date"><input id="wf-s-date" type="date" className={input} value={f.work_date} onChange={(e) => setF({ ...f, work_date: e.target.value })} data-testid="wf-s-date" /></Field>
        <Field id="wf-s-reason" label="Override reason (Founder/Admin, double booking only)"><input id="wf-s-reason" className={input} value={f.override_reason} onChange={(e) => setF({ ...f, override_reason: e.target.value })} data-testid="wf-s-reason" /></Field>
        <fieldset className="sm:col-span-3 flex flex-wrap gap-2"><legend className="text-sm font-medium">Crew</legend>
          {workers.map((w) => (
            <label key={w.id} className="inline-flex items-center gap-2 min-h-[44px] px-2 border rounded"><input type="checkbox" checked={f.worker_ids.includes(w.id)} onChange={() => toggle(w.id)} data-testid={`wf-s-worker-${w.id}`} />{w.name}</label>))}
        </fieldset>
        <button type="button" className={primary} onClick={save} data-testid="wf-s-save">Schedule crew</button>
      </Card>
      <Alert text={err} testid="wf-schedule-error" />
      {conf.length > 0 && <ul className="text-sm text-red-800" data-testid="wf-conflicts">{conf.map((c, i) => <li key={i} data-testid={`wf-conflict-${c.type}`}>{c.worker}: {LABEL[c.type]}{c.certification ? ` (${c.certification})` : ""}</li>)}</ul>}
    </section>
  );
}
